<template>
  <div class="page-outer">
    <div class="preview-wrap" v-loading="loading">
      <el-tabs v-model="activeCount" @tab-click="handleClick" class="top-tabs">
        <el-tab-pane
          v-for="accountItem of dataList"
          :key="accountItem.accountId"
          :label="accountItem.accountName"
          :name="accountItem.accountId"
        >
          <div class="count-area">
            <el-tabs v-model="activeGroup" type="card" class="group-tabs">
              <el-tab-pane
                v-for="groupItem of accountItem.groupList"
                :key="groupItem.groupId"
                :label="groupItem.groupName"
                :name="groupItem.groupId"
              >
                <div class="group-area">
                  <div class="group-status" v-if="!alreadyProjectId">
                    <span>项目状态：</span>
                    <el-switch class="" @change="changeGroupStatus(groupItem)" v-model="groupItem.campaignStatus"> </el-switch>
                  </div>
                  <div class="btn-list">
                    <el-button
                      type="primary"
                      @click="changeAdStatus(selectCampaign[groupItem.groupName], false)"
                      :disabled="!selectCampaign[groupItem.groupName] || selectCampaign[groupItem.groupName].length === 0"
                      >批量暂停</el-button
                    >
                    <el-button
                      type="primary"
                      @click="changeAdStatus(selectCampaign[groupItem.groupName], true)"
                      :disabled="!selectCampaign[groupItem.groupName] || selectCampaign[groupItem.groupName].length === 0"
                      >批量开启</el-button
                    >
                  </div>
                  <div class="table-wrap">
                    <el-table
                      ref="table"
                      :data="groupItem.groupTableList"
                      style="width: 100%"
                      :max-height="tableHeight"
                      @selection-change="handleSelectionChange($event, groupItem)"
                    >
                      <el-table-column type="selection" width="60px"> </el-table-column>
                      <el-table-column label="状态" width="100px">
                        <template slot-scope="scope">
                          <el-switch @change="changeAdStatus([scope.row], scope.row.adSetStatus, false)" v-model="scope.row.adSetStatus">
                          </el-switch>
                        </template>
                      </el-table-column>
                      <el-table-column label="广告" width="300px">
                        <template slot-scope="scope">
                          <div class="cell-wrap">
                            <div>{{ scope.row.adSetName }}</div>
                            <video
                              controls="controls"
                              style="min-width: 140px; max-height: 130px"
                              :src="scope.row.material"
                              v-if="scope.row.materialType === 'video'"
                            ></video>
                            <img :src="scope.row.material" style="min-width: 140px; max-height: 130px" v-else />
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column label="下载方式" width="250px">
                        <template slot-scope="scope">
                          <div class="cell-wrap">
                            <span class="cell-label">下载方式</span>
                            <span class="cell-value">{{ scope.row.downloadType }}</span>
                            <span class="cell-label">优化目标</span>
                            <span class="cell-value">{{ scope.row.adConvert }}</span>
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column label="预算与出价" width="250px">
                        <template slot-scope="scope">
                          <div class="cell-wrap">
                            <span class="cell-label">竞价策略</span>
                            <span class="cell-value">{{ scope.row.chargeMode }}</span>
                            <span class="cell-label">预算</span>
                            <span class="cell-value">{{ scope.row.budget }}</span>
                            <span class="cell-label">出价</span>
                            <span class="cell-value">{{ scope.row.cpaBid }}</span>
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column label="定向" width="250px">
                        <template slot-scope="scope">
                          <div class="cell-wrap">
                            <span class="cell-label">性别</span>
                            <span class="cell-value">{{
                              scope.row.gender === "GENDER_FEMALE" ? "女" : scope.row.gender === "GENDER_MALE" ? "男" : "不限"
                            }}</span>
                            <span class="cell-label">自定义人群</span>
                            <span class="cell-value"
                              >{{ scope.row.audienceType }}
                              <el-tooltip placement="top">
                                <div slot="content">
                                  <div class="hover-wrap" style="font-size: 12px">
                                    <div style="font-weight: bold">定向</div>
                                    <div style="margin-top: 6px">
                                      {{ scope.row.audience ? scope.row.audience.retargeting_tags_include.join() : "" }}
                                    </div>
                                    <div style="margin-top: 10px; font-weight: bold">排除</div>
                                    <div style="margin-top: 6px">
                                      {{ scope.row.audience ? scope.row.audience.retargeting_tags_exclude.join() : "" }}
                                    </div>
                                  </div>
                                </div>
                                <i v-show="scope.row.audienceType === '自定义'" class="el-icon-question"></i>
                              </el-tooltip>
                            </span>
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column prop="address" label="创意" min-width="250px">
                        <template slot-scope="scope">
                          <div class="cell-wrap">
                            <span class="cell-label">{{ scope.row.creativeGroupName }}</span>
                            <span class="cell-value">{{ scope.row.videoNum || 0 }}个视频</span>
                            <span class="cell-value">{{ scope.row.imageNum || 0 }}个图片</span>
                            <span class="cell-value">{{ scope.row.titleNum || 0 }}个标题</span>
                          </div>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                </div>
              </el-tab-pane>
            </el-tabs>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div class="bottom-btnlist">
      <el-button class="bot-btn" @click="goBack">返回</el-button>
      <el-button class="bot-btn primary" :loading="pushLoading" @click="pushAdvertise">发布广告</el-button>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { getIndustry, getCrowdTag, adPublish_ttV2, updateOpenStatus, getPreviewList_ttV2 } from "@/api/promotion.js";
export default {
  components: {},
  data() {
    return {
      activeCount: "",
      activeGroup: "",
      dataList: [],
      industryList: [],
      optionList: [],
      selectCampaign: {},
      pushLoading: false,
      loading: false,
      templateId: null, //当前预览的id
      tableHeight: window.innerHeight - 345,
    };
  },
  activated() {
    this.initData();
    this.initTableOptions();
  },
  methods: {
    initTableOptions() {
      //创意分类列表
      getIndustry().then((res) => {
        if (res.code === "0000") {
          this.industryList = res.industries;
        }
      });
      //人群包列表
      getCrowdTag({
        advertiserId: this.adCount,
      }).then((res) => {
        if (res.code === "0000") {
          this.optionList = res.crowdTags;
          //格式化人群包数据
          this.formatRqbData();
        }
      });
    },
    handleSelectionChange(val, data) {
      this.$set(this.selectCampaign, data.groupName, val);
    },
    changeAdStatus(list, flag, isBatch = true) {
      updateOpenStatus({ ids: list.map((item) => item.adSetId), isOpen: flag, type: 2, version: "v2" }).then((res) => {
        if (res.code === "0000") {
          this.selectCampaign = [];
          if (isBatch) {
            this.initData();
          }
          this.$message.success("操作成功");
        }
      });
    },
    changeGroupStatus(data) {
      updateOpenStatus({ ids: [data.groupTableList[0].campaignId], isOpen: data.campaignStatus, type: 1, version: "v2" }).then((res) => {
        if (res.code === "0000") {
          this.$message.success("操作成功");
          // this.initData();
        }
      });
    },
    formatRqbData() {
      this.dataList.forEach((countItem) => {
        countItem.groupList.forEach((groupItem) => {
          groupItem.groupTableList.forEach((tableLine) => {
            if (tableLine.audience) {
              tableLine.audience.retargeting_tags_exclude = tableLine.audience.retargeting_tags_exclude.map((id) => {
                let item = this.optionList.find((item) => item.custom_audience_id === id);
                return item ? item.name : "-";
              });
              tableLine.audience.retargeting_tags_include = tableLine.audience.retargeting_tags_include.map((id) => {
                let item = this.optionList.find((item) => item.custom_audience_id === id);
                return item ? item.name : "-";
              });
            }
          });
        });
      });
    },
    handleClick() {
      let selectCount = this.dataList.find((item) => item.accountId === this.activeCount);
      if (selectCount) {
        this.activeGroup = selectCount.groupList[0].groupId;
      }
      this.$nextTick(() => {
        this.$refs.table.doLayout();
      });
    },
    formatData(data) {
      let dataList = [];
      for (let [accountId, groupList] of Object.entries(data)) {
        let newGroupList = groupList.map((groupItem) => {
          let [[groupName, groupTable]] = Object.entries(groupItem);
          return {
            campaignStatus: groupTable[0].campaignStatus,
            groupId: String(Math.random()),
            groupName: groupName,
            groupTableList: groupTable,
          };
        });
        dataList.push({
          accountId: accountId,
          accountName: this.advertiserName || "-",
          groupList: newGroupList,
        });
      }
      return dataList;
    },
    initData() {
      this.loading = true;
      this.templateId = this.$route.params.templateId;
      getPreviewList_ttV2({
        templateId: this.$route.params.templateId,
      })
        .then((res) => {
          this.dataList = this.formatData(res.data);
          this.activeCount = this.dataList[0].accountId;
          this.activeGroup = this.dataList[0].groupList[0].groupId;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    goBack() {
      this.$router.go(-1);
    },
    pushAdvertise() {
      this.pushLoading = true;
      adPublish_ttV2({
        templateId: this.$route.params.templateId,
      }).then((res) => {
        this.pushLoading = false;
        if (res.code === "0000") {
          this.$confirm("提交成功，可在任务中心 查看进度", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "查看进度",
            type: "success",
          })
            .then(() => {
              this.$router.replace("/promotion.html");
            })
            .catch(() => {
              this.$router.replace({
                name: "proTable",
                query: {
                  key: "TaskCenter",
                },
              });
            });
        }
      });
    },
  },
  computed: {
    ...mapState({
      adCount: (state) => state.PromotionTtV2.baseData.advertiser_id,
      alreadyProjectId: (state) => state.PromotionTtV2.baseData.projectId,
      advertiserName: (state) => state.PromotionTtV2.baseData.advertiserName,
    }),
  },
};
</script>

<style lang="less" scoped>
.page-outer {
  .preview-wrap {
    margin: 16px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.12);
    border-radius: 4px;
    min-height: 400px;
    .top-tabs {
      /deep/ .el-tabs__nav {
        margin-left: 24px;
      }
    }
    .group-tabs {
      /deep/ .el-tabs__nav {
        margin-left: 0px;
      }
      /deep/ .el-tabs__header {
        margin: 0px;
      }
      /deep/ .el-tabs__item {
        background-color: rgba(0, 0, 0, 0.02);
        color: rgba(0, 0, 0, 0.65);
        font-size: 14px;
        &.is-active {
          background-color: #fff;
          color: rgba(24, 144, 255, 1);
          font-weight: bold;
        }
      }
    }
    .count-area {
      margin-left: 24px;
      padding-right: 24px;
    }
    .group-area {
      min-height: 400px;
      margin-bottom: 24px;
      border-right: 1px solid #e4e7ed;
      border-bottom: 1px solid #e4e7ed;
      border-left: 1px solid #e4e7ed;
      .group-status {
        margin: 12px 24px;
        font-size: 15px;
      }
      .budget {
        color: rgba(0, 0, 0, 0.65);
        font-size: 14px;
        padding: 20px;
      }
      .btn-list {
        padding-left: 20px;
        .btn {
          color: rgba(24, 144, 255, 1);
          font-size: 14px;
          border-radius: 2px;
          border: 1px solid rgba(24, 144, 255, 1);
          background: rgba(255, 255, 255, 1);
          .btn-icon {
            margin-right: 4px;
          }
        }
      }
      .table-wrap {
        margin-top: 16px;
        /deep/ td {
          vertical-align: top;
        }
        .cell-wrap {
          .cell-label {
            display: block;
            color: rgba(0, 0, 0, 0.65);
            font-weight: bold;
            font-size: 14px;
            // margin-top: 6px;
          }
          .cell-value {
            display: block;
            color: rgba(0, 0, 0, 0.65);
            font-size: 14px;
          }
          .table-cascader {
            line-height: 0px !important;
            /deep/ input {
              border: none;
              color: rgba(0, 0, 0, 0.65);
              font-size: 14px;
              background-color: transparent;
              padding: 0px;
              height: 15px;
            }
            /deep/ .el-input {
              line-height: 15px !important;
            }
            /deep/ .el-input__suffix {
              display: none;
            }
          }
        }
      }
    }
  }
  .bottom-btnlist {
    height: 100px;
    padding-left: 16px;
    .bot-btn {
      height: 40px;
      width: 117px;
      color: rgba(24, 144, 255, 1);
      font-size: 14px;
      border-radius: 2px;
      border: 1px solid rgba(24, 144, 255, 1);
      &.primary {
        color: #fff;
        background: rgba(24, 144, 255, 1);
      }
    }
  }
}
</style>
